import React, { useState, useEffect, useContext, useRef } from 'react';
import MaterialTable, { MTableToolbar } from 'material-table';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Container, createMuiTheme, Toolbar, Typography, CssBaseline, Tooltip, Snackbar, FormControl, InputLabel, Select, Divider, FormControlLabel, Checkbox, TextField, IconButton, Button, AppBar } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import MuiAlert from '@material-ui/lab/Alert';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import ExportIcon from '@material-ui/icons/GetApp';
import FilterListIcon from '@material-ui/icons/FilterList';
import 'date-fns';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { ConvertToCurrentTimeZone } from '../header/timeFormatter';
import { HttpService } from '../../apiAuthorization/httpService';
import { GlobalTheme } from '../../layouts/theme';
import { Context } from '../contexts/siteContext';
import { Modules } from '../contexts/modulesContext';
import { Theme } from '../contexts/themeContext';
import Card from '../card/card.js';
import CardBody from '../card/cardBody.js';
import SmallMenu from '../header/smallMenu';
import StatusIcon from '../common/statusIcon';
import ContentDialog from '../common/contentDialog.js'
import PrintDialog from './printDialog.js'

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '7px 0px',
            width: '100%'
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    error: {
        fontSize: '12px',
        fontWeight: "bold",
        color: 'red',
        marginTop: '-5px'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    title: {
        flex: 1
    }
}));

export default function POSObservationLogReport(props) {
    const classes = useStyles();
    const { defaultSite, sites } = useContext(Context);
    const { trainingMode } = useContext(Modules);
    const { theme } = useContext(Theme);
    const [sitesList, setSitesList] = useState([]);
    const [locations, setlocations] = useState([]);
    const [posRisks, setPosRisks] = useState([]);
    const [risks, setRisks] = useState([]);
    const [classifications, setClassifications] = useState([]);
    const [observationReasons, setObservationReasons] = useState([]);
    const [observationReason, setObservationReason] = useState(0);
    const [transactionLog, setTransactionLog] = useState([]);
    const [startDate, setStartDate] = useState(ConvertToCurrentTimeZone(new Date(), "L", null, defaultSite));
    const [endDate, setEndDate] = useState(ConvertToCurrentTimeZone(new Date(), "L", 24, defaultSite));
    const [siteId, setSiteId] = useState(-1);
    const [location, setLocation] = useState([]);
    const [risk, setRisk] = useState(0);
    const [classification, setClassification] = useState(0);
    const [completed, setCompleted] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [showDetail, setShowDetail] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [backDrop, setBackDrop] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [posGroupId, setPOSGroupId] = useState(defaultSite.IntegratedSystem.POSGroupId);
    const [isShowPrintDialog, setIsShowPrintDialog] = useState(false);
    const printDialogRef = useRef();
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);
    const tableHeight = window.innerHeight - (showFilter ? 419 : 210);

    const getColumns = (posGroupId) => {
        return [
            { field: 'PatientName', title: 'Patient Name', width: '10%' },
            { field: (posGroupId === 1) ? 'Risk' : 'ObservationReasons', title: (posGroupId === 1) ? 'Risk Type' : 'Observation Reasons', width: '15%' },
            { field: 'LocationPath', title: 'Location', width: '35%' },
            { field: 'ReportStartDate', title: 'Start', width: '10%' },
            { field: 'ReportEndDate', title: 'End', width: '10%' },
            { field: 'Hours', title: 'Hours', width: '8%' }
        ]
    };

    const [patientSittings, setPatientSittings] = useState({
        columns: getColumns(posGroupId),
        data: []
    });
    const [patientSittingDetail, setPatientSittingDetail] = useState({});
    const [observationLogs, setObservationLogs] = useState({
        columns: [],
        data: []
    });

    const [transferHistories, setTransferHistories] = useState({
        columns: [
            { field: 'LocationPath', title: 'Location', width: '30%' },
            { field: 'Bed', title: 'Bed', width: '10%' },
            { field: 'TransferDateTimeString', title: 'Time', width: '10%' },
        ],
        data: []
    });

    const triggerSave = () => {
        if (showDetail) {
            setShowDetail(false);
        }
        else {
            updateAppTransactionLog();
            props.history.push({ pathname: "/" });
        }
    };

    const rowStyle = (rowData, rowIndex) => {
        return {
            border: "1px solid",
            borderColor: (rowData.Flag || rowData.Lock) ? "red" : (rowIndex % 2 === 0 ? "" : ""),
            color: (rowData.Flag || rowData.Lock) ? "red" : "inherit"
        };
    };

    const closeSuccessSnackbar = () => {
        setOpenSuccess(false);
    };

    const filterChanged = () => {
        setShowFilter(!showFilter);
    };

    const siteChanged = (e) => {
        let index = sites.findIndex(item => item.id === parseInt(e.target.value));
        let groupId = (index === -1) ? 1 : sites[index].IntegratedSystem.POSGroupId;
        if (groupId !== posGroupId) {
            setPOSGroupId(groupId);
            setPatientSittings({ ...patientSittings, columns: getColumns(groupId) });
        }
        setSiteId(parseInt(e.target.value));
        if (parseInt(e.target.value) > 0) {
            getLocations(parseInt(e.target.value));
        }
        else {
            let data = [];
            data.unshift({ GeoLocationId: 0, GeoLocationBranchName: "All" });
            setlocations(data);
            setLocation(data[0]);
        }
    };

    const riskChanged = (e) => {
        setRisk(parseInt(e.target.value));

        let riskClassifications = [];
        for (let index = 0; index < posRisks.length; index++) {
            if (posRisks[index].ParentRiskId !== "0") {
                let parentRiskIds = posRisks[index].ParentRiskId?.split(",");
                for (let iIndex = 0; iIndex < parentRiskIds.length; iIndex++) {
                    if (parseInt(parentRiskIds[iIndex], 10) === parseInt(e.target.value))
                        riskClassifications.push(posRisks[index]);
                }
            }
        }

        riskClassifications.unshift({ RiskId: 0, Risk: "All" });
        setClassifications(riskClassifications);
    };

    const observationReasonChanged = (e) => {
        setObservationReason(parseInt(e.target.value));
    };

    const showObservation = (item) => {
        let patientSittingDto = {};
        patientSittingDto.Id = item.Id;
        patientSittingDto.StartDate = item.ReportStartDate;
        patientSittingDto.EndDate = item.ReportEndDate;
        patientSittingDto.Requestor = item.Requestor;
        patientSittingDto.RequestType = item.RequestType;
        patientSittingDto.Attendant = item.Attendant;
        patientSittingDto.LocationPath = item.LocationPath;
        patientSittingDto.Bed = item.Bed;
        patientSittingDto.PatientName = item.PatientName;
        patientSittingDto.DateBirth = item.DateBirth;
        patientSittingDto.PatientType = item.PatientType;
        patientSittingDto.IsolationPatient = item.IsolationPatient;
        patientSittingDto.MedicalRecordNumber = item.MedicalRecordNumber;
        patientSittingDto.Risk = item.Risk;
        patientSittingDto.ShowSafetyCheck = item.ShowSafetyCheck;
        patientSittingDto.SafetyCheckCount = item.SafetyCheckCount;
        patientSittingDto.PatientDemographic = item.PatientDemographic;
        patientSittingDto.ObservationReasons = item.ObservationReasons;
        patientSittingDto.POSGroupId = item.POSGroupId;
        patientSittingDto.SiteId = item.SiteId;
        if (item.POSGroupId === 1) {
            let riskClassifications = item.RiskClassificationId?.split(',');
            let selectedClassifications = "";
            riskClassifications.forEach(r => {
                let posRisk = posRisks.filter(x => x.RiskId === parseInt(r));
                if (posRisk.length > 0)
                    selectedClassifications += posRisk[0].Risk + ",";
            });
            patientSittingDto.RiskClassificationId = selectedClassifications.substring(0, selectedClassifications.length - 1);
        }
        setPatientSittingDetail(patientSittingDto);
        getObservationLogs(item.Id, item.SiteId, item.ShowSafetyCheck, item.POSGroupId);
        setShowDetail(true);
    };

    const getRisks = () => {
        setBackDrop(true);
        HttpService.post("/PatientSitting/GetPOSRisk")
            .then((result) => {
                let data = result.data.filter(x => x.ParentRiskId === "0");
                data.unshift({ RiskId: 0, Risk: "All" });
                setPosRisks(result.data);
                setRisks(data);
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const getObservationReasons = () => {
        setBackDrop(true);
        HttpService.post('/PatientSitting/GetObservationReasons', { POSGroupId: 2 })
            .then((result) => {
                let data = result.data;
                data.unshift({ Id: 0, Description: "All" });
                setObservationReasons(data);
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const getLocations = (id) => {
        setBackDrop(true);
        HttpService.post("/PatientSitting/GetGeoLocations", {
            siteId: id,
        })
            .then((result) => {
                let data = result.data;
                data.unshift({ GeoLocationId: 0, GeoLocationBranchName: "All" });
                setlocations(data);
                setLocation(data[0]);
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const getPatientSittings = () => {
        let model = {};
        let riskIndex = risks.findIndex(item => item.RiskId === risk);
        let classificationIndex = classifications.findIndex(item => item.RiskId === classification);
        model.SiteId = siteId;
        model.FilterStartDate = startDate;
        model.FilterEndDate = endDate;
        model.LocationId = (!showFilter || location === null || location.length === 0) ? 0 : location.GeoLocationId;
        model.Risk = (!showFilter || riskIndex === -1 || posGroupId === 2) ? "All" : risks[riskIndex].Risk;
        model.RiskClassificationId = (!showFilter || classificationIndex === -1 || posGroupId === 2) ? null : classifications[classificationIndex].Risk;
        model.ObservationReasonIds = (!showFilter || observationReason === 0 || posGroupId === 1) ? "" : observationReason.toString();
        model.Status = (showFilter && completed) ? "Completed" : "";
        model.TrainingMode = trainingMode;
        model.AccessibleSites = sitesList;
        setBackDrop(true);

        HttpService.post("/PatientSitting/GetPatientSittingsForReport", model)
            .then((result) => {
                setPatientSittings({ ...patientSittings, data: result.data });
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                });
    };

    const getObservationLogs = (patientSittingId, siteId, showSafetyCheck, groupId) => {
        let model = {};
        model.AppPatientSittingId = patientSittingId;
        model.SiteId = siteId;
        model.PageCount = 0;
        model.CalledByPage = "Reports";
        model.ShowSafetyCheck = showSafetyCheck;

        setBackDrop(true);
        HttpService.post("/PatientSitting/GetObservationLog", model)
            .then((result) => {
                var _columns = [];
                if (groupId === 1) {
                    _columns = [
                        { field: 'ObservationTimeString', title: 'Time', width: '10%' },
                        { field: 'SafetyCheckText', title: 'Safety Check', width: '10%', hidden: !showSafetyCheck },
                        { field: 'Observer', title: 'Observer', width: '10%' },
                        { field: 'ObservationText', title: 'Observation', width: '30%' },
                        { field: 'InterventionText', title: 'Intervention', width: '30%' },
                        { field: 'Comments', title: 'Comments', width: '10%' }
                    ]
                }
                else {
                    _columns = [
                        { field: 'ObservationTimeString', title: 'Time', width: '10%' },
                        { field: 'Observer', title: 'Observer', width: '10%' },
                        { field: 'ObservationText', title: 'Observation', width: '50%' },
                        { field: 'LocationText', title: 'Location', width: '30%' }
                    ]
                }
                setObservationLogs({ ...observationLogs, columns: _columns, data: result.data });
                setTransferHistories({ ...transferHistories, data: result.locationHistories });
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                });
    };

    const printOption = () => {
        setIsShowPrintDialog(true);
    };

    const processBulkExport = (fileFormat) => {
        exportToPDF("ObservationLogReport", fileFormat)
    };

    const exportToPDF = (reportName, fileFormat) => {
        let model = {};
        let url = "";

        if (reportName === "ObservationLogReport") {
            let riskIndex = risks.findIndex(item => item.RiskId === risk);
            let classificationIndex = classifications.findIndex(item => item.RiskId === classification);

            url = "/PatientSitting/ObservationLogExportAll";
            model.SiteId = siteId;
            model.FilterStartDate = startDate;
            model.FilterEndDate = endDate;
            model.LocationId = (!showFilter || location.length === 0) ? 0 : location.GeoLocationId;
            model.Risk = (!showFilter || riskIndex === -1 || posGroupId === 2) ? "All" : risks[riskIndex].Risk;
            model.RiskClassificationId = (!showFilter || classificationIndex === -1 || posGroupId === 2) ? null : classifications[classificationIndex].Risk;
            model.ObservationReasonIds = (!showFilter || observationReason === 0 || posGroupId === 1) ? "" : observationReason.toString();
            model.Status = (showFilter && completed) ? "Completed" : "";
            model.TrainingMode = trainingMode;
            model.AccessibleSites = sitesList;
            model.FileFormat = fileFormat;
        }
        else if (reportName === "ObservationLogDetailReport") {
            let escalationList = [];

            url = "/PatientSitting/ObservationLogDetailExport";
            escalationList.push({ AppPatientSittingId: patientSittingDetail.Id, SiteId: patientSittingDetail.SiteId, PageCount: 0 });
            model = patientSittingDetail;
            model.EscalationList = escalationList;
        }

        setBackDrop(true);
        HttpService.post(url, model)
            .then((result) => {
                if (result.success) {
                    addAppTransactionLog("POS Observation Log Member - Print", "Print");
                    let fileName = result.name;
                    HttpService.downloadFile('/Report/DownloadFile', { fileName: fileName })
                        .then((response) => {
                            const url = window.URL.createObjectURL(new Blob([response]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.download = fileName;
                            document.body.appendChild(link);
                            link.click();
                            link.parentNode.removeChild(link);
                        });
                }
                else {
                    setSuccessMessage(result.message);
                    setOpenSuccess(true);
                }
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                });
    };

    const addAppTransactionLog = (reportName, actionType) => {
        HttpService.post("/AppTransactionLog/SaveAppTransactionLog", { ReportName: reportName, ActionType: actionType })
            .then((result) => {
                if (actionType === "Access") {
                    setTransactionLog(result.data);
                }
            },
                (error) => {
                    console.log(error);
                });
    };

    const updateAppTransactionLog = () => {
        HttpService.post("/AppTransactionLog/UpdateAppTransactionLog", transactionLog)
            .then((result) => {
            },
                (error) => {
                    console.log(error);
                });
    };

    useEffect(() => {
        if (sitesList.length > 0) {
            getPatientSittings();
        }
        // eslint-disable-next-line 
    }, [startDate, endDate, location, risk, classification, observationReason, completed]);

    useEffect(() => {
        getRisks();
        getObservationReasons();
        getLocations(defaultSite.id);
        let data = sites.slice();
        let index = sites.findIndex(item => item.id === 0);
        if (index === -1) {
            data.unshift({ id: 0, name: "All" });
            setSitesList(data);
        }
        addAppTransactionLog("POS Observation Log Member - Access", "Access");
        // eslint-disable-next-line 
    }, []);

    useEffect(() => {
        setSiteId(defaultSite.id);
        // eslint-disable-next-line 
    }, [sitesList]);

    return (
        <React.Fragment>
            <ThemeProvider theme={currentTheme}>
                <CssBaseline />
                <Backdrop className={classes.backdrop} id="posObservationBackdrop" open={backDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar open={openSuccess} autoHideDuration={3000} onClose={closeSuccessSnackbar} style={{ height: "100%" }}>
                    <Alert onClose={closeSuccessSnackbar} severity="success">
                        {successMessage}
                    </Alert>
                </Snackbar>
                <ContentDialog maxWidth={"sm"} title="Export Option" confirmName={' OK '} open={isShowPrintDialog} close={() => setIsShowPrintDialog(false)} onConfirm={() => { printDialogRef.current.save() }} >
                    <PrintDialog ref={printDialogRef} close={() => setIsShowPrintDialog(false)} processBulkExport={processBulkExport}></PrintDialog>
                </ContentDialog>
                <Container maxWidth="xl" height="100%" className={props.styles}>
                    <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={triggerSave} aria-label="back">
                                <KeyboardBackspaceIcon />
                            </IconButton>
                            <Grid container direction="row" alignItems="center">
                                <Grid item>
                                    <Typography variant="h6" className={classes.title}>POS Observation Log Report</Typography>
                                </Grid>
                                <Grid item>
                                    <StatusIcon />
                                </Grid>
                            </Grid>
                            <Grid container justify="flex-end">
                                {
                                    (props.location.settingMenus.indexOf("POS Observation Log Member - Print") > -1) && <>
                                        {!showDetail &&
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                className={classes.button}
                                                style={{ background: currentTheme.secondary, width: "120px", marginRight: "10px" }}
                                                startIcon={<ExportIcon />}
                                                type="button"
                                                onClick={e => printOption()}
                                            >
                                                Print All
                                            </Button>
                                        }
                                        {showDetail &&
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                className={classes.button}
                                                style={{ background: currentTheme.secondary, width: "120px", marginRight: "10px" }}
                                                startIcon={<ExportIcon />}
                                                type="button"
                                                onClick={e => exportToPDF("ObservationLogDetailReport", "")}
                                            >
                                                Print Log
                                            </Button>
                                        }
                                    </>}
                                <SmallMenu modified={false} />
                                {!showDetail &&
                                    <Tooltip title="Filter" arrow>
                                        <FilterListIcon style={{ cursor: "pointer", float: "right", width: "30px", marginTop: "12px", marginLeft: "20px" }} onClick={filterChanged} />
                                    </Tooltip>
                                }
                            </Grid>
                        </Toolbar>
                    </AppBar>
                    <Card color="primary" style={{ height: "100%", background: currentTheme.background }}>
                        <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                            {!showDetail && <>
                                <div className={classes.root} autoComplete="off">
                                    <Grid
                                        container
                                        direction="row"
                                        alignItems="center"
                                        spacing={1}>
                                        <Grid item xs={12} sm={6}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDatePicker disableToolbar fullWidth autoOk
                                                    variant="inline"
                                                    inputVariant="outlined"
                                                    id="StartDate"
                                                    label="Start Date"
                                                    format="MM/dd/yyyy"
                                                    size="small"
                                                    value={startDate}
                                                    onChange={date => setStartDate(moment(date).format("MM/DD/YYYY"))}
                                                    InputAdornmentProps={{ position: "start" }}
                                                    PopoverProps={{
                                                        anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                        transformOrigin: { horizontal: "left", vertical: "top" }
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDatePicker disableToolbar fullWidth autoOk
                                                    variant="inline"
                                                    inputVariant="outlined"
                                                    id="EndDate"
                                                    label="End Date"
                                                    format="MM/dd/yyyy"
                                                    size="small"
                                                    minDate={startDate}
                                                    value={endDate}
                                                    onChange={date => setEndDate(moment(date).format("MM/DD/YYYY"))}
                                                    InputAdornmentProps={{ position: "start" }}
                                                    PopoverProps={{
                                                        anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                        transformOrigin: { horizontal: "left", vertical: "top" }
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                    </Grid>
                                    {showFilter && <>
                                        <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                                            <InputLabel htmlFor="Site">Site</InputLabel>
                                            <Select
                                                native
                                                label="Site"
                                                size="small"
                                                value={siteId}
                                                onChange={(e) => { siteChanged(e); }}
                                            >
                                                {
                                                    sitesList.map((option, key) => {
                                                        return <option key={option.id} value={option.id} label={option.name} >{option.name}</option>;
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                        <Autocomplete
                                            id="Location"
                                            size="small"
                                            openOnFocus
                                            disabled={(siteId <= 0)}
                                            value={location}
                                            options={locations}
                                            getOptionLabel={(option) => option.GeoLocationBranchName || ""}
                                            onChange={(event, option) => setLocation(option)}
                                            renderInput={(params) => <TextField {...params} label="Location" variant="outlined" />}
                                        />
                                        {(posGroupId === 1) &&
                                            <>
                                                <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                                                    <InputLabel htmlFor="Risk">Risk</InputLabel>
                                                    <Select
                                                        native
                                                        label="Risk"
                                                        size="small"
                                                        value={risk}
                                                        onChange={(e) => { riskChanged(e); }}
                                                    >
                                                        {
                                                            risks.map((option, key) => {
                                                                return <option key={option.RiskId} value={option.RiskId} label={option.Risk} >{option.Risk}</option>;
                                                            })
                                                        }
                                                    </Select>
                                                </FormControl>
                                                {(risk > 0) &&
                                                    <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                                                        <InputLabel htmlFor="Classification">Classification</InputLabel>
                                                        <Select
                                                            native
                                                            label="Classification"
                                                            size="small"
                                                            value={classification}
                                                            onChange={(e) => { setClassification(parseInt(e.target.value)); }}
                                                        >
                                                            {
                                                                classifications.map((option, key) => {
                                                                    return <option key={option.RiskId} value={option.RiskId} label={option.Risk} >{option.Risk}</option>;
                                                                })
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                }
                                            </>
                                        }
                                        {(posGroupId === 2) &&
                                            <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                                                <InputLabel htmlFor="ObservationReason">Reason for Observation</InputLabel>
                                                <Select
                                                    native
                                                    label="ObservationReason"
                                                    size="small"
                                                    value={observationReason}
                                                    onChange={(e) => { observationReasonChanged(e); }}
                                                >
                                                    {
                                                        observationReasons.map((option, key) => {
                                                            return <option key={option.Id} value={option.Id} label={option.Description} >{option.Description}</option>;
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        }
                                        <FormControlLabel
                                            style={{ width: "auto", margin: "0px 5px", color: "inherit" }}
                                            value="end"
                                            control={<Checkbox color="primary" checked={completed} />}
                                            label="Show Completed"
                                            labelPlacement="end"
                                            onChange={e => setCompleted(e.target.checked)}
                                        />
                                    </>
                                    }
                                </div>
                                <Divider style={{ height: "1px", backgroundColor: currentTheme.secondary, marginTop: "5px", marginBottom: "10px" }} />
                                <div style={{ maxWidth: '100%' }}>
                                    <MaterialTable
                                        columns={patientSittings.columns}
                                        data={patientSittings.data}
                                        components={{
                                            Toolbar: (props) => (
                                                <div
                                                    style={{
                                                        height: "0px",
                                                    }}
                                                >
                                                    <MTableToolbar {...props} />
                                                </div>
                                            )
                                        }}
                                        style={{ backgroundColor: currentTheme.background, border: "1px solid white" }}
                                        options={{
                                            filtering: false,
                                            search: false,
                                            paging: false,
                                            actionsColumnIndex: -1,
                                            minBodyHeight: tableHeight,
                                            maxBodyHeight: tableHeight,
                                            headerStyle: {
                                                fontWeight: "bold", color: currentTheme.headerColor, backgroundColor: currentTheme.headerBackground
                                            },
                                            actionsCellStyle: {
                                                color: currentTheme.secondary,
                                                hover: "white"
                                            },
                                            rowStyle: rowStyle
                                        }}
                                        onRowClick={(evt, selectedRow) => showObservation(selectedRow)}
                                    />
                                </div>
                            </>}
                            {showDetail && <>
                                <div className={classes.root} autoComplete="off">
                                    <Grid
                                        container
                                        direction="row"
                                        alignItems="center"
                                        spacing={1}>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label="Start Date"
                                                size="small"
                                                variant="outlined"
                                                value={patientSittingDetail.StartDate}
                                                fullWidth
                                                InputProps={{
                                                    readOnly: true
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label="End Date"
                                                size="small"
                                                variant="outlined"
                                                value={patientSittingDetail.EndDate}
                                                fullWidth
                                                InputProps={{
                                                    readOnly: true
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <TextField
                                        label="Requestor"
                                        size="small"
                                        variant="outlined"
                                        value={patientSittingDetail.Requestor}
                                        fullWidth
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                    <TextField
                                        label="Attendant"
                                        size="small"
                                        variant="outlined"
                                        value={patientSittingDetail.Attendant}
                                        fullWidth
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                    <TextField
                                        label="Location"
                                        size="small"
                                        variant="outlined"
                                        value={patientSittingDetail.LocationPath}
                                        fullWidth
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                    <TextField
                                        label="Bed"
                                        size="small"
                                        variant="outlined"
                                        value={patientSittingDetail.Bed}
                                        fullWidth
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                    <TextField
                                        label="Patient Name"
                                        size="small"
                                        variant="outlined"
                                        value={patientSittingDetail.PatientName}
                                        fullWidth
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                    <TextField
                                        label="DOB"
                                        size="small"
                                        variant="outlined"
                                        value={patientSittingDetail.DateBirth}
                                        fullWidth
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                    {(patientSittingDetail.POSGroupId === 1) &&
                                        <TextField
                                            label="Patient Type"
                                            size="small"
                                            variant="outlined"
                                            value={patientSittingDetail.PatientType}
                                            fullWidth
                                            InputProps={{
                                                readOnly: true
                                            }}
                                        />
                                    }
                                    {(patientSittingDetail.POSGroupId === 2) &&
                                        <TextField
                                            label="Patient Demographic"
                                            size="small"
                                            variant="outlined"
                                            value={patientSittingDetail.PatientDemographic}
                                            fullWidth
                                            InputProps={{
                                                readOnly: true
                                            }}
                                        />
                                    }
                                    <TextField
                                        label="Isolation Patient"
                                        size="small"
                                        variant="outlined"
                                        value={patientSittingDetail.IsolationPatient}
                                        fullWidth
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                    <TextField
                                        label={patientSittingDetail.POSGroupId === 1 ? "MRN" : "FIN"}
                                        size="small"
                                        variant="outlined"
                                        value={patientSittingDetail.MedicalRecordNumber}
                                        fullWidth
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                    {(patientSittingDetail.POSGroupId === 1) &&
                                        <>
                                            <TextField
                                                label="Risk"
                                                size="small"
                                                variant="outlined"
                                                value={patientSittingDetail.Risk}
                                                fullWidth
                                                InputProps={{
                                                    readOnly: true
                                                }}
                                            />
                                            <TextField
                                                label="Classification"
                                                size="small"
                                                variant="outlined"
                                                value={patientSittingDetail.RiskClassificationId}
                                                fullWidth
                                                InputProps={{
                                                    readOnly: true
                                                }}
                                            />
                                        </>
                                    }
                                    {(patientSittingDetail.POSGroupId === 2) &&
                                    <>
                                        <TextField
                                            label="Patient Type"
                                            size="small"
                                            variant="outlined"
                                            value={patientSittingDetail.PatientType}
                                            fullWidth
                                            InputProps={{
                                                readOnly: true
                                            }}
                                        />
                                        <TextField
                                            label="Reason for Observation"
                                            size="small"
                                            variant="outlined"
                                            value={patientSittingDetail.ObservationReasons}
                                            fullWidth
                                            InputProps={{
                                                readOnly: true
                                            }}
                                        />
                                    </>
                                    }
                                    <div style={{ maxWidth: "100%" }}>
                                        <Typography variant="h6" id="tableTitle">
                                            Observation Log
                                        </Typography>
                                        <MaterialTable
                                            columns={observationLogs.columns}
                                            data={observationLogs.data}
                                            components={{
                                                Toolbar: (props) => (
                                                    <div
                                                        style={{
                                                            height: "0px",
                                                        }}
                                                    >
                                                        <MTableToolbar {...props} />
                                                    </div>
                                                )
                                            }}
                                            style={{ backgroundColor: currentTheme.background, border: "1px solid white" }}
                                            options={{
                                                filtering: false,
                                                search: false,
                                                paging: false,
                                                actionsColumnIndex: -1,
                                                minBodyHeight: "55vh", maxBodyHeight: "55vh",
                                                headerStyle: {
                                                    fontWeight: "bold", color: currentTheme.headerColor, backgroundColor: currentTheme.headerBackground
                                                },
                                                actionsCellStyle: {
                                                    color: currentTheme.secondary,
                                                    hover: "white"
                                                },
                                                rowStyle: rowStyle
                                            }}
                                        />
                                    </div>

                                    <div style={{ maxWidth: "100%" }}>
                                        <Typography variant="h6" id="tableTitle">
                                            Transfer History
                                        </Typography>
                                        <MaterialTable
                                            columns={transferHistories.columns}
                                            data={transferHistories.data}
                                            components={{
                                                Toolbar: (props) => (
                                                    <div
                                                        style={{
                                                            height: "0px",
                                                        }}
                                                    >
                                                        <MTableToolbar {...props} />
                                                    </div>
                                                )
                                            }}
                                            style={{ backgroundColor: currentTheme.background, border: "1px solid white" }}
                                            options={{
                                                filtering: false,
                                                search: false,
                                                paging: false,
                                                actionsColumnIndex: -1,
                                                minBodyHeight: "55vh", maxBodyHeight: "55vh",
                                                headerStyle: {
                                                    fontWeight: "bold", color: currentTheme.headerColor, backgroundColor: currentTheme.headerBackground
                                                },
                                                actionsCellStyle: {
                                                    color: currentTheme.secondary,
                                                    hover: "white"
                                                },
                                                rowStyle: rowStyle
                                            }}
                                        />
                                    </div>
                                </div>
                            </>}
                        </CardBody>
                    </Card>
                </Container>
            </ThemeProvider>
        </React.Fragment>
    )
}
